export default __webpack_public_path__ + "static/media/necklace_light.2a9603ef.png";